export default __webpack_public_path__ + "static/media/sampling2.7604c482.jpg";